import { Fragment } from 'react'
import { clsx } from 'clsx'
import { CheckIcon } from '@heroicons/react/20/solid'

export default function Wizard({ steps, currentStep, onStepClick, className = '' }) {
  return (
    <div className={clsx('wizard relative', className)}>
      <nav aria-label="Progress">
        <ol className="flex items-center">
          {steps.map((step, stepIdx) => (
            <li key={step.id} className={clsx('relative flex-shrink-0', stepIdx !== steps.length - 1 && 'pr-8 sm:pr-16')}>
              {/* Connector */}
              {stepIdx !== steps.length - 1 && (
                <div
                  className="absolute inset-0 flex items-center pointer-events-none"
                  aria-hidden="true"
                  style={{ left: '1.25rem', right: '1.25rem' }}
                >
                  <div className="h-0.5 w-full bg-gray-200 dark:bg-gray-700 relative">
                    {step.completed && (
                      <div className="absolute h-full bg-primary-600 dark:bg-primary-400 transition-all duration-300" style={{ width: '100%' }} />
                    )}
                  </div>
                </div>
              )}
              
              {/* Step */}
              <button
                type="button"
                onClick={() => onStepClick && onStepClick(stepIdx)}
                disabled={!step.completed && currentStep < stepIdx}
                className={clsx(
                  'relative flex h-10 w-10 items-center justify-center rounded-full border-2 transition-all z-10',
                  'shadow-sm',
                  step.completed
                    ? 'border-primary-600 bg-primary-600 dark:border-primary-400 dark:bg-primary-400 shadow-primary-500/20'
                    : currentStep === stepIdx
                    ? 'border-primary-600 bg-white dark:bg-gray-800 dark:border-primary-400 shadow-primary-500/10'
                    : 'border-gray-300 bg-white dark:bg-gray-800 dark:border-gray-600',
                  !step.completed && currentStep < stepIdx && 'cursor-not-allowed opacity-50',
                  (step.completed || currentStep >= stepIdx) && 'cursor-pointer hover:border-primary-700 dark:hover:border-primary-300 hover:scale-105'
                )}
                aria-current={currentStep === stepIdx ? 'step' : undefined}
              >
                {step.completed ? (
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" />
                ) : (
                  <span
                    className={clsx(
                      'h-3 w-3 rounded-full transition-colors',
                      currentStep === stepIdx
                        ? 'bg-primary-600 dark:bg-primary-400'
                        : 'bg-transparent'
                    )}
                    aria-hidden="true"
                  />
                )}
                <span className="sr-only">{step.name}</span>
              </button>
              
              {/* Step Label - Abajo del círculo */}
              {step.label && (
                <div className={clsx(
                  'absolute top-12 left-1/2 -translate-x-1/2 whitespace-nowrap',
                  'text-[10px] font-medium leading-tight',
                  currentStep === stepIdx
                    ? 'text-primary-600 dark:text-primary-400'
                    : step.completed
                    ? 'text-gray-600 dark:text-gray-400'
                    : 'text-gray-400 dark:text-gray-500'
                )}>
                  {step.label}
                </div>
              )}
            </li>
          ))}
        </ol>
      </nav>
      
      {/* Step Names */}
      <div className="mt-16 sm:mt-14 flex justify-between">
        {steps.map((step, stepIdx) => (
          <div
            key={step.id}
            className={clsx(
              'flex-1 text-center px-1',
              stepIdx < steps.length - 1 && 'pr-2 sm:pr-4'
            )}
          >
            <div
              className={clsx(
                'text-xs font-semibold leading-tight',
                currentStep === stepIdx
                  ? 'text-primary-600 dark:text-primary-400'
                  : step.completed
                  ? 'text-gray-900 dark:text-white'
                  : 'text-gray-500 dark:text-gray-400'
              )}
            >
              {step.name}
            </div>
            {step.description && (
              <div className="mt-0.5 text-[10px] leading-tight text-gray-500 dark:text-gray-400">
                {step.description}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

